(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initPd(el) {
      if (el.dataset.pdInit === 'true') return;

      var inner = el.querySelector('.yoshi-pd__inner');
      var outer = el.querySelector('.yoshi-pd__outer');
      var btn = el.querySelector('.yoshi-pd__toggle');
      var label = el.querySelector('.yoshi-pd__toggle-label');
      if (!inner || !outer || !btn || !label) return;

      el.dataset.pdInit = 'true';

      var moreLabel = el.getAttribute('data-more') || 'Lire la suite';
      var lessLabel = el.getAttribute('data-less') || 'Réduire';

      // Contenu déjà court : tout afficher et masquer le bouton.
      if (inner.scrollHeight - inner.clientHeight < 4) {
        inner.classList.add('is-open');
        outer.classList.add('is-open');
        btn.hidden = true;
        return;
      }

      btn.hidden = false;

      btn.addEventListener('click', function () {
        var opening = !inner.classList.contains('is-open');
        inner.classList.toggle('is-open', opening);
        outer.classList.toggle('is-open', opening);
        btn.classList.toggle('is-open', opening);
        btn.setAttribute('aria-expanded', String(opening));
        label.textContent = opening ? lessLabel : moreLabel;
      });
    }

    function boot() {
      var nodes = document.querySelectorAll('.yoshi-pd');
      for (var i = 0; i < nodes.length; i++) {
        initPd(nodes[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
